const FAVORITES_KEY = 'servernox:nav-favorites';
export const DEFAULT_FAVORITES = ['/ai-coding', '/websites', '/docker', '/terminal'];

function getStorage(): Storage | null {
  try {
    return typeof window !== 'undefined' && window.localStorage ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function getFavoritePaths(): string[] {
  const storage = getStorage();
  if (!storage) return DEFAULT_FAVORITES;
  try {
    const raw = storage.getItem(FAVORITES_KEY);
    if (!raw) return DEFAULT_FAVORITES;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed.map(String) : DEFAULT_FAVORITES;
  } catch {
    return DEFAULT_FAVORITES;
  }
}

export function toggleFavoritePath(path: string): boolean {
  const storage = getStorage();
  const current = new Set(getFavoritePaths());
  let added: boolean;
  if (current.has(path)) {
    current.delete(path);
    added = false;
  } else {
    current.add(path);
    added = true;
  }
  if (storage) {
    try {
      storage.setItem(FAVORITES_KEY, JSON.stringify(Array.from(current)));
      if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('servernox:favorites-updated'));
      }
    } catch {}
  }
  return added;
}

export function isFavoritePath(path: string): boolean {
  return getFavoritePaths().includes(path);
}
